import { DetailsPageUploader } from '__generated__/DetailsPageUploader';
import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import AttachmentUploader from 'common/components/uploader/AttachmentUploader';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    powerpointFiles: StructuredBriefFile[];
}

interface Props<T> {
    form: ObservableForm<T>;
    uploader: DetailsPageUploader;
    required?: boolean;
}

const PowerpointFilesField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    uploader,
    required = false,
}) => {
    return (
        <Field
            form={form}
            name="powerpointFiles"
            title={__('Add PowerPoint files')}
            required={required}
            message={__('Upload any PowerPoint presentation files that your designer needs.')}
            render={() => (
                <AttachmentUploader uploader={uploader} {...form.attach('powerpointFiles')} />
            )}
        />
    );
};

export default PowerpointFilesField;
